import React from 'react';

import Form from '../../../../vendor/react-validation/components/form';
import ValidationButton from '../../../Forms/Components/ValidationButton';
import TextInput from '../../../Forms/Components/TextInput';
import Checkbox from '../../../Forms/Components/Checkbox';
import getFormValues from '../../../Forms/getFormValues';
import {required, isIntegerBetweenLengthRange} from '../../../Forms/Validation/rules';
import {InputHeading} from '../../../Forms/FormStyles/formStyles';

export const NOTICE_TYPE_SUCCESS = 'success';
export const NOTICE_TYPE_FAILURE = 'failure';

class Notice extends React.Component {

    onRetryClick() {
        if (this.props.onRetryClick) {
            this.props.onRetryClick();
        }
    }

    render() {
        const iconClasses = ['extend-student-insurance-notice__header__icon'];
        const actions = [];

        if (this.props.type) {
            iconClasses.push('extend-student-insurance-notice__header__icon--' + this.props.type);
        }
        
        if (this.props.type === NOTICE_TYPE_FAILURE) {
            actions.push((
                <button key="retry-btn" className="my-pages-btn" onClick={() => {this.onRetryClick(); }}>Försök igen</button>
            ));
        }

        return (
            <div className="extend-student-insurance-notice">
                <div className="extend-student-insurance-notice__header">
                    <div className={iconClasses.join(' ')}></div>
                </div>
                <div className="extend-student-insurance-notice__content">
                    <div className="extend-student-insurance-notice__content__description">{this.props.description}</div>
                </div>
                <div className="extend-student-insurance-notice__actions">{actions}</div>
            </div>
        );
    }
}

export default Notice;